<template>
    <flex-container
        class="handover-send-message-form"
        direction="column"
        color="white"
        :padding="Size.md"
        align-content="stretch"
    >
        <div class="handover-send-message-form__input">
            <input-group
                v-model="content"
                @keydown.enter="sendMessage"
            >
                <template #input>
                    <flex-container
                        :gap="Size.xs"
                    >
                        <text-input
                            placeholder="Antwoorden..."
                            no-border
                        />
                    </flex-container>
                </template>
            </input-group>
        </div>
        <flex-container
            align-items="center"
            justify-content="space-between"
        >
            <flex-container size="auto">
                <button-plain-icon
                    v-if="false"
                    :color="'gray-300'"
                    :icon="TextIcon"
                    :size="IconSize.sm"
                    is-custom-icon
                />
                <button-plain-icon
                    v-if="false"
                    :color="'gray-300'"
                    :icon="FaceSmileRelaxedIcon"
                    :size="IconSize.sm"
                    is-custom-icon
                />
                <button-plain-icon
                    v-if="false"
                    :color="'gray-300'"
                    :icon="PaperclipIcon"
                    :size="IconSize.sm"
                    is-custom-icon
                />
            </flex-container>

            <flex-container size="auto">
                <expandable-button
                    :options="options"
                    @click="sendMessage"
                    @collapse-click="onCollapseClick"
                >
                    Verzenden
                </expandable-button>
            </flex-container>
        </flex-container>
    </flex-container>

    <confirmation-dialog
        ref="closeChatConfirmationDialog"
        label="Chat beëindigen"
        description="Weet je zeker dat je deze chat wilt beëindigen?"
        hide-close
    >
        <template #actions>
            <button-text @click="hideCloseCurrentChatDialog">
                Annuleren
            </button-text>
            <button-block @loading="closeCurrentChat">
                Beëindigen
            </button-block>
        </template>
    </confirmation-dialog>
    <handover-forward-chat-modal ref="forwardHandoverForm" :chat-id="props.chatId" />
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import TextIcon from '@keyvue/one-awesome-icons/icons/regular/text.svg?component';
    import FaceSmileRelaxedIcon from '@keyvue/one-awesome-icons/icons/regular/face-smile-relaxed.svg?component';
    import PaperclipIcon from '@keyvue/one-awesome-icons/icons/regular/paperclip.svg?component';
    import ExpandableButton from '@/ai/assistent/components/forms/ExpandableButton.vue';
    import { ChatId, CloseChatCommand, SendEmployeeMessageCommand } from '@keyvue/one-api-client';
    import { ButtonBlock, ButtonPlainIcon, ButtonState, type ButtonStateChangedEvent, ButtonText, type ExposedOverlay, FlexContainer, IconSize, InputGroup, Size } from '@keyvue/one-ui';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import HandoverForwardChatModal from '@/ai/assistent/components/forms/HandoverForwardChatModal.vue';

    const props = defineProps<{ chatId: ChatId }>();
    const { client, currentUser } = useClient();

    const closeChatConfirmationDialog = ref<ExposedOverlay>();
    const forwardHandoverForm = ref<{ overlay: ExposedOverlay }>();

    const content = ref('');
    const options = ref([{
        value: 'handover-chat',
        label: 'Gesprek overdragen',
    }, {
        value: 'close-chat',
        label: 'Gesprek voltooien',
    }]);

    async function sendMessage(event?: ButtonStateChangedEvent) {
        if (content.value.length === 0) {
            event?.button.setState(ButtonState.content);
            return;
        }

        const command = new SendEmployeeMessageCommand(
            props.chatId,
            currentUser.value.id,
            content.value,
        );

        await client.dispatch(command);
        content.value = '';

        if (event?.button) {
            event.button.setState(ButtonState.completed);
        }
    }

    async function onCollapseClick(value: string) {
        if (value === 'close-chat') {
            showCloseCurrentChatDialog();
        }
        if (value === 'handover-chat') {
            handoverCurrentHandoverChat();
        }
    }

    async function closeCurrentChat(event: ButtonStateChangedEvent) {
        const command = new CloseChatCommand(props.chatId);
        await client.dispatch(command);
        event.button.setState(ButtonState.completed);
        hideCloseCurrentChatDialog();
    }

    function showCloseCurrentChatDialog() {
        closeChatConfirmationDialog.value?.openOverlay();
    }

    function handoverCurrentHandoverChat() {
        forwardHandoverForm.value?.overlay?.openOverlay();
    }

    function hideCloseCurrentChatDialog() {
        closeChatConfirmationDialog.value?.closeOverlay();
    }
</script>

<style scoped lang="scss">
    .handover-send-message-form {
        position: sticky;
        bottom: 0;
        border-top: 1px solid var(--theme-colors-default--gray-300);
    }
</style>
